export var createPdfPasswordInputScreenEvent = function createPdfPasswordInputScreenEvent() {
  return {
    eventType: 'screen',
    action: 'viewed',
    actionSubject: 'mediaViewerPdfPasswordInputScreen',
    name: 'mediaViewerPdfPasswordInputScreen'
  };
};